import script from "./admin-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-layout.vue?vue&type=script&setup=true&lang=js"

import "./admin-layout.vue?vue&type=style&index=0&id=4726f577&lang=scss&scoped=true"
import "./admin-layout.vue?vue&type=style&index=1&id=4726f577&lang=scss"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4726f577"]])

export default __exports__